import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

/**
 * The clear button a font field puts after itself, drawn inside the field's right end as the old plugin's box had it.
 * An empty field has nothing to clear and shows none.
 */
@Component({
  selector: 'app-font-picker-clear',
  template: `
    @if (!empty()) {
      <button type="button" title="Clear" [attr.aria-label]="field() ? 'Clear ' + field() + ' font' : 'Clear font'"
              (click)="cleared.emit()">
        <i class="fa-solid fa-circle-xmark" aria-hidden="true"></i>
      </button>
    }`,
  styles: `
    :host {
      position: absolute;
      top: 50%;
      right: 0.375rem;
      z-index: 5;
      transform: translateY(-50%);
    }

    button {
      padding: 0 0.25rem;
      border: 0;
      background: none;
      color: var(--text-muted);
      line-height: 1;
    }

    button:hover {
      color: var(--text-primary);
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FontPickerClearComponent {
  /** The field's label, which names the button. */
  readonly field = input('');
  readonly empty = input(false);
  readonly cleared = output<void>();
}
